import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/api/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Request failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-admin-surface p-6">
      <form onSubmit={onSubmit} className="w-full max-w-sm space-y-4 bg-admin-panel border border-admin-border rounded-md p-6">
        <div className="flex justify-center mb-2">
          <Logo variant="wordmark" className="text-3xl" />
        </div>
        <h1 className="font-head text-lg font-semibold text-center">Reset your password</h1>
        {sent ? (
          <div className="space-y-4 text-center">
            <p className="text-sm text-muted-foreground">
              If an account exists for that email, you'll receive a reset link shortly.
            </p>
            <a href="/login" className="inline-block text-gold text-sm font-medium hover:underline">
              Back to sign in
            </a>
          </div>
        ) : (
          <>
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
            <Button className="w-full" disabled={busy}>{busy ? "Sending…" : "Send reset link"}</Button>
          </>
        )}
      </form>
    </div>
  );
}
